import { assign } from '@xstate/immer';
import { asLayoutEffect } from '@xstate/react';

function findOption(ctx, value) {
    return ctx.options.find(function (opt) { return opt.value === value; });
}
function findOptionIndex(ctx, value) {
    return ctx.options.findIndex(function (opt) { return opt.value === value; });
}
function getNextOption(ctx, currentIndex, direction) {
    var step = direction === "up" ? -1 : 1;
    var last = ctx.options.length - 1;
    var index = currentIndex + step;
    // wrap from top to bottom or vice-versa
    if (index < 0)
        index = last;
    if (index > last)
        index = 0;
    while (ctx.options[index].disabled) {
        // break if we've done a full cycle
        if (index === currentIndex)
            break;
        index += step;
        // wrap from top to bottom or vice-versa
        if (index < 0)
            index = last;
        if (index > last)
            index = 0;
    }
    return ctx.options[index];
}
function getFirstOption(ctx) {
    return getNextOption(ctx, -1, "down");
}
function getLastOption(ctx) {
    return getNextOption(ctx, ctx.options.length, "up");
}
function getNextOptionFromActive(ctx, direction) {
    var defaultIndex = direction === "up" ? 0 : ctx.options.length - 1;
    if (!ctx.activeOption) {
        return getNextOption(ctx, defaultIndex, direction);
    }
    var activeIdx = findOptionIndex(ctx, ctx.activeOption.value);
    return getNextOption(ctx, activeIdx >= 0 ? activeIdx : defaultIndex, direction);
}
var actions = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onActiveChanged: assign(function () {
        // onActiveChanged is defined and used by selectStateMachineActionsSelectActive
    }),
    onSelectCallback: function (ctx) {
        var _a;
        if (ctx.activeOption) {
            var option = findOption(ctx, ctx.activeOption.value);
            if (option)
                (_a = ctx.onSelect) === null || _a === void 0 ? void 0 : _a.call(ctx, option);
        }
    },
    setDefaultActiveOptionDown: assign(function (ctx) {
        if (ctx.activeOption)
            return;
        var selectOpts = ctx.options.filter(function (opt) { return !opt.disabled && opt.selected; });
        ctx.activeOption = selectOpts.length
            ? selectOpts[0]
            : ctx.options.find(function (opt) { return !opt.disabled; });
    }),
    // did this have a use case?
    // setDefaultActiveOptionUp: assign((ctx) => {
    //   if (ctx.activeOption) return;
    //   const selectOpts = ctx.options.filter(
    //     (opt) => !opt.disabled && opt.selected
    //   );
    //   if (selectOpts.length) {
    //     ctx.activeOption = selectOpts[selectOpts.length - 1];
    //   } else {
    //     const enabledOpts = ctx.options.filter((opt) => !opt.disabled);
    //     ctx.activeOption = enabledOpts[enabledOpts.length - 1];
    //   }
    // }),
    focusOnTrigger: asLayoutEffect(function (ctx) {
        var _a, _b;
        (_b = (_a = ctx.refs.triggerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus({ preventScroll: true });
    }),
    moveActiveDown: assign(function (ctx) { return (ctx.activeOption = getNextOptionFromActive(ctx, "down")); }),
    moveActiveToFirst: assign(function (ctx) { return (ctx.activeOption = getFirstOption(ctx)); }),
    moveActiveToLast: assign(function (ctx) { return (ctx.activeOption = getLastOption(ctx)); }),
    moveActiveUp: assign(function (ctx) { return (ctx.activeOption = getNextOptionFromActive(ctx, "up")); }),
    makeActiveSelected: assign(function (ctx) {
        var activeOption = ctx.activeOption;
        if (activeOption) {
            ctx.options[findOptionIndex(ctx, activeOption.value)].selected = true;
            ctx.options.forEach(function (option) {
                option.selected = option.value === activeOption.value;
            });
        }
    }),
    setActiveOption: assign(function (ctx, event) {
        var _a;
        var value = event.currentTarget.dataset.value;
        if (((_a = ctx.activeOption) === null || _a === void 0 ? void 0 : _a.value) !== value) {
            var option = findOption(ctx, value);
            if ((option === null || option === void 0 ? void 0 : option.value) && !option.disabled) {
                ctx.activeOption = option;
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }),
    unsetActiveOption: assign(function (ctx, event) {
        var _a;
        var value = event.currentTarget.dataset.value;
        if (((_a = ctx.activeOption) === null || _a === void 0 ? void 0 : _a.value) === value) {
            ctx.activeOption = undefined;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }),
    toggleOptionSelection: assign(function (ctx, event) {
        var optionValue = event.value;
        if (optionValue) {
            var option = findOption(ctx, optionValue);
            if (option) {
                if (option.selected) {
                    option.selected = false;
                }
                else if (ctx.multiple) {
                    option.selected = true;
                }
                else {
                    ctx.options.forEach(function (opt) {
                        opt.selected = opt.value === optionValue;
                    });
                }
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }),
    toggleActiveSelected: assign(function (ctx) {
        var active = ctx.activeOption;
        if (!active)
            return;
        var option = findOption(ctx, active.value);
        if (option) {
            if (!option.selected) {
                ctx.options.forEach(function (opt) {
                    opt.selected = opt.value === active.value;
                });
            }
        }
    }),
    setOptions: assign(function (ctx, event) {
        ctx.activeOption = undefined;
        ctx.options = event.options;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }),
};

export { actions, findOption, findOptionIndex, getFirstOption, getLastOption, getNextOptionFromActive };
//# sourceMappingURL=actions.js.map
